import React, { useState } from 'react';

const TimeDropdown = ({ value, onChange, onClose, isMinTime = false }) => {
  const [selectedHour, setSelectedHour] = useState(value ? value.split(":")[0] : "00");
  const [selectedMinute, setSelectedMinute] = useState(value ? value.split(":")[1] : "00");
  
  const hours = Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0'));
  const minutes = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));

  const handleNow = () => {
    const now = new Date();
    const hour = now.getHours().toString().padStart(2, '0');
    const minute = now.getMinutes().toString().padStart(2, '0');
    setSelectedHour(hour);
    setSelectedMinute(minute);
    onChange(`${hour}:${minute}`);
    onClose();
  };

  const handleHourChange = (hour) => {
    setSelectedHour(hour);
    onChange(`${hour}:${selectedMinute}`);
    if (selectedMinute !== "00") onClose();
  };

  const handleMinuteChange = (minute) => {
    setSelectedMinute(minute);
    onChange(`${selectedHour}:${minute}`);
    if (selectedHour !== "00") onClose();
  };

  const handleOk = () => {
    // For minimum time, prevent 0:0 selection
    if (isMinTime && selectedHour === "00" && selectedMinute === "00") {
      // Set to 1 minute if user tries to select 0:0
      setSelectedMinute("01");
      onChange(`${selectedHour}:01`);
    } else {
      onChange(`${selectedHour}:${selectedMinute}`);
    }
    onClose();
  };

  return (
    <div className="absolute z-50 mt-1 w-56 bg-white rounded-lg shadow-lg border border-accent-light/20">
      <div className="p-3 grid grid-cols-2 gap-4">
        {/* Hours Column */}
        <div>
          <div className="text-sm font-medium text-accent-dark mb-2 px-2">Hours</div>
          <div className="h-48 overflow-y-auto custom-scrollbar">
            {hours.map((hour) => (
              <div
                key={hour}
                className={`px-4 py-2 cursor-pointer rounded-md ${
                  selectedHour === hour 
                    ? 'bg-primary-light/10 text-primary-headings' 
                    : 'hover:bg-accent-light/5'
                }`}
                onClick={() => handleHourChange(hour)}
              >
                {hour}
              </div>
            ))}
          </div>
        </div>

        {/* Minutes Column */}
        <div>
          <div className="text-sm font-medium text-accent-dark mb-2 px-2">Minutes</div>
          <div className="h-48 overflow-y-auto custom-scrollbar">
            {minutes.map((minute) => (
              <div
                key={minute}
                className={`px-4 py-2 cursor-pointer rounded-md ${
                  selectedMinute === minute 
                    ? 'bg-primary-light/10 text-primary-headings' 
                    : 'hover:bg-accent-light/5'
                }`}
                onClick={() => handleMinuteChange(minute)}
              >
                {minute}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      <div className="p-3 border-t border-accent-light/20 flex justify-end space-x-2">
        {/* <button
          type="button"
          onClick={handleNow}
          className="px-3 py-1.5 text-sm text-accent-dark hover:bg-accent-light/5 rounded-md transition-colors"
        >
          Now
        </button> */}
        <button
          type="button"
          onClick={handleOk}
          className="px-3 py-1.5 text-sm bg-primary-headings text-white rounded-md hover:bg-primary-headings/90 transition-colors"
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default TimeDropdown; 